import DividerDesktopSvg from './divider-desktop.svg';
import DividerMobileSvg from './divider-mobile.svg';

export { DividerDesktopSvg, DividerMobileSvg };
